export enum BorrowerStatus {
  New = 'new',
  Existing = 'existing',
  Former = 'former',
}
